type Params = {
	projectKey: string;
	pinUrl?: string;
	shouldStayProjectScope: boolean;
};

export const getStarredFilterLink = ({
	projectKey,
	pinUrl,
	shouldStayProjectScope,
}: Params): string => {
	if (!projectKey) {
		throw new Error(`Expected projectKey to be a valid string, got: ${projectKey}`);
	}

	// xxx/issues?filter=123 -> xxx/issues
	const craftedPinUrl = !pinUrl ? `/projects/${projectKey}/issues` : pinUrl.replace(/\?.*$/, '');

	return shouldStayProjectScope ? craftedPinUrl : '/issues/';
};
